module.exports = __webpack_public_path__ + "Poppins-Regular.3a8872f975ad316e7085.eot";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/OESS_LFB_V2demo/src/assets/fonts/Poppins-Regular.eot
// module id = ../../../../../src/assets/fonts/Poppins-Regular.eot
// module chunks = main